var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5021 12.7851C24.5032 11.9333 24.4311 11.083 24.2868 10.2435H12.499V15.0576H19.2505C19.1124 15.8265 18.82 16.5594 18.3909 17.2122C17.9619 17.8651 17.4051 18.4243 16.7541 18.8561V21.981H20.7835C23.1428 19.8057 24.5021 16.5888 24.5021 12.7851Z",
    fill: "#4471FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4991 25C15.8722 25 18.7124 23.8924 20.7835 21.9827L16.7542 18.8578C15.6327 19.6182 14.1883 20.0523 12.4991 20.0523C9.23878 20.0523 6.47151 17.8544 5.48196 14.8927H1.33105V18.1131C2.37141 20.1833 3.96669 21.9236 5.93879 23.1397C7.91088 24.3558 10.1822 24.9999 12.4991 25Z",
    fill: "#4471FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48189 14.8926C4.95875 13.3407 4.95875 11.66 5.48189 10.1081V6.8877H1.33098C0.455797 8.62922 0 10.5513 0 12.5004C0 14.4494 0.455797 16.3715 1.33098 18.113L5.48189 14.8926Z",
    fill: "#4471FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4991 4.94857C14.2816 4.91945 16.0041 5.59296 17.2941 6.82351L20.8617 3.25592C18.5994 1.13112 15.6025 -0.0354271 12.4991 0.00082009C10.1822 0.000925686 7.91088 0.644991 5.93879 1.86111C3.96669 3.07723 2.37141 4.81754 1.33105 6.88775L5.48196 10.1081C6.47151 7.14642 9.23878 4.94857 12.4991 4.94857Z",
    fill: "#4471FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.09d007592904bb1e25b187418521260f.svg";
export { ForwardRef as ReactComponent };